// extracted by mini-css-extract-plugin
export default {"mobileFilters":"catalog-view_mobileFilters__CTm1v","desktopFilters":"catalog-view_desktopFilters__WJbCv"};